import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import SuggestLocation, {
  ISuggestLocationProps,
  ILocationSuggestion,
} from 'transfix-ui/components/SuggestLocation'

type IBaseControllerProps = ControllerProps<React.ComponentType<ISuggestLocationProps>>

export interface IControlledSuggestLocationProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  /**
   * @default {}
   */
  SuggestLocationProps?: Partial<ISuggestLocationProps>
}

const ControlledSuggestLocation = ({
  control,
  name,
  defaultValue,
  SuggestLocationProps = {},
}: IControlledSuggestLocationProps) => {
  return (
    <Controller
      defaultValue={defaultValue}
      name={name}
      control={control}
      render={({ onBlur, onChange, value }) => {
        const onChangeHandler = (result: Partial<ILocationSuggestion> | undefined) => {
          onChange({
            city: result?.city,
            state: result?.state,
            countryCode: result?.countryCode || 'US',
          })
        }

        return (
          <SuggestLocation
            required
            value={value}
            onChange={onChangeHandler}
            placeholder='Enter a city'
            onBlur={onBlur}
            {...SuggestLocationProps}
          />
        )
      }}
    />
  )
}

export default ControlledSuggestLocation
